import { PhoneCall, ShieldCheck, Sparkles, Handshake } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const LIFESTYLE_IMG = "https://images.unsplash.com/photo-1782056094508-c756e31b04d0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxjb21wYWN0JTIwY2l0eSUyMGNhciUyMGZpYXQlMjA1MDAlMjBzdXYlMjBkcml2aW5nJTIwY29hc3R8ZW58MHx8fHwxNzkyNDE0OTc5fDA&ixlib=rb-4.1.0&q=85";
const VAN_IMG = "https://images.unsplash.com/photo-1774012697049-cd341ab317ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHw0fHx3aGl0ZSUyMGRlbGl2ZXJ5JTIwdmFuJTIwZHJpdmluZyUyMHJvYWQlMjBoaWdod2F5JTIwZGF5bGlnaHR8ZW58MHx8fHwxNzkyNDE1NzcxfDA&ixlib=rb-4.1.0&q=85";

export const Bento = () => (
  <section id="perche-noi" className="py-24 sm:py-32 bg-[#fafafa]" data-testid="bento-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-8">
      <Reveal>
        <p className="text-xs font-mono font-semibold uppercase tracking-[0.25em] text-emerald-700 mb-4">Perché noi</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 max-w-2xl mb-14">
          Quattro motivi per cui chi noleggia con noi, torna.
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        <Reveal className="lg:col-span-7" delay={0.05}>
          <div className="group relative h-full min-h-[320px] rounded-3xl overflow-hidden border border-slate-200" data-testid="bento-partnership">
            <img src={LIFESTYLE_IMG} alt="Guida in Italia con Noleggio Sicuro" loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/30 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8">
              <Handshake className="w-8 h-8 text-emerald-400 mb-4" />
              <h3 className="font-display text-xl sm:text-2xl font-bold text-white">Partnership DoYou Italy</h3>
              <p className="mt-2 text-sm text-slate-300 max-w-md leading-relaxed">
                Noleggio Sicuro opera in collaborazione con DoYou Italy: una rete affidabile, standard verificati e presenza su tutto il territorio nazionale.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-5" delay={0.12}>
          <div className="h-full min-h-[320px] rounded-3xl bg-slate-900 p-8 flex flex-col justify-between border border-slate-800" data-testid="bento-phone">
            <PhoneCall className="w-8 h-8 text-emerald-400" />
            <div>
              <h3 className="font-display text-xl sm:text-2xl font-bold text-white">Telefonata diretta, zero centralini</h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">
                Parli subito con un operatore reale. Prenotazioni, modifiche e assistenza con una sola chiamata.
              </p>
              <a
                href="tel:+393773899146"
                data-testid="bento-phone-link"
                className="mt-5 inline-block font-display text-2xl sm:text-3xl font-extrabold text-emerald-400 hover:text-emerald-300 transition-colors duration-300"
              >
                +39 377 389 9146
              </a>
            </div>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-5" delay={0.05}>
          <div className="h-full min-h-[280px] rounded-3xl bg-white p-8 border border-slate-200 flex flex-col justify-between hover:border-emerald-600/40 transition-colors duration-500" data-testid="bento-insurance">
            <ShieldCheck className="w-8 h-8 text-emerald-600" />
            <div>
              <h3 className="font-display text-xl sm:text-2xl font-bold text-slate-900">Coperture chiare, nero su bianco</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                Assicurazioni e franchigie spiegate prima della firma. Il prezzo che vedi è il prezzo che paghi.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={0.12}>
          <div className="group relative h-full min-h-[280px] rounded-3xl overflow-hidden border border-slate-200" data-testid="bento-fleet-care">
            <img src={VAN_IMG} alt="Furgone in viaggio su autostrada" loading="lazy" className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-950/30 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8">
              <Sparkles className="w-8 h-8 text-emerald-400 mb-4" />
              <h3 className="font-display text-xl sm:text-2xl font-bold text-white">Flotta sanificata e revisionata</h3>
              <p className="mt-2 text-sm text-slate-300 max-w-md leading-relaxed">
                Ogni veicolo viene controllato, tagliandato e igienizzato prima di ogni consegna. Sali a bordo e parti, al resto pensiamo noi.
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
